import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrnTooltipImports } from '@spartan-ng/brain/tooltip';
import { HlmBadgeDirective } from '@spartan-ng/ui-badge-helm';
import { HlmTooltipImports } from '@spartan-ng/ui-tooltip-helm';

type WcagLevelMapInfo = {
    level: string;
    description: string;
}

const wcagLevelMap: Record<string, WcagLevelMapInfo> = {
    wcag2a: {
        level: 'A',
        description: 'Information and user interface components must be presentable to users in ways they can perceive.'
    },
    wcag2aa: {
        level: 'AA',
        description: 'User interface components and navigation must be operable.'
    }
} as const;

type WcagLevelMap = typeof wcagLevelMap;

export type WcagLevel = keyof WcagLevelMap;

@Component({
    selector: 'sona-wcag-level-cell',
    standalone: true,
    template: `
        @if (_levelInfo(); as levelInfo) {
            <hlm-tooltip>
                <span hlmBadge hlmTooltipTrigger size="lg" variant="outline" class="tw-cursor-help">
                   {{ levelInfo.level }}
                </span>
                <div *brnTooltipContent class="tw-max-w-80">
                    <div class="tw-font-medium tw-text-lg tw-mb-1">{{ 'REPORTS.COMPONENT.WCAG_LEVEL_CELL.TITLE' | translate:levelInfo }}</div>
                    <div class="tw-text-muted-foreground">{{ 'REPORTS.COMPONENT.WCAG_LEVEL_CELL.DESCRIPTION' | translate:levelInfo }}</div>
                </div>
            </hlm-tooltip>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        HlmBadgeDirective,
        HlmTooltipImports,
        BrnTooltipImports,
        TranslatePipe
    ],
    host: {
        class: 'tw-block'
    }
})
export class SonaWcagLevelCellComponent {
    readonly level = input.required<WcagLevel | null>();
    protected readonly _levelInfo = computed(() => {
        const level = this.level();
        return level ? wcagLevelMap[level] : null;
    });
}
